module.exports = __webpack_public_path__ + "media/images/yoga-337ba173cfeb1faff5cf54a5365dbc0c.svg";